import React, { useEffect, useState } from 'react'
import { liveLocationPostApi } from '../../Api/DeliveryBarest'
import BottomNavigation from '../../Components/BottomNavigation/BottomNavigation'
import OrderDelivered from '../../Components/OrderDelivered/OrderDelivered'
import OrderOnDelivery from '../../Components/OrderOnDelivery/OrderOnDelivery'
import Style from './OrderCondition.module.css'
const OrderCondition = () => {
    const[checkTable,setCheckTable]=useState(true)
    const MINUTE_MS=6000
    useEffect(()=>{
      const interval = setInterval(() => {
        getLocation()
      }, MINUTE_MS);
      return () => clearInterval(interval)
    },[])
    
    var x = document.getElementById("demo");
    function getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      } else { 
        x.innerHTML = "Geolocation is not supported by this browser.";
      }
    }
    
    function showPosition(position) {
      LiveLocationPost(position)
    }
  
    const LiveLocationPost=(position)=>{
      let info = {
        lat:position.coords.latitude,
        lon:position.coords.longitude
      }
      liveLocationPostApi(info,res=>{
        alert("Call shod")
      })
    }
    return (
        <div className={Style.PageHolder}>
            <section className={Style.tabHolder}>
                <div className={checkTable?Style.onFocus:Style.cursor} onClick={()=>setCheckTable(true)}>  سفارش در حال تحویل</div>
                <div className={checkTable?Style.cursor:Style.onFocus} onClick={()=>setCheckTable(false)}> سفارش تحویل داده شده</div>
            </section>
            {
                checkTable?<OrderOnDelivery/>:<OrderDelivered/>
            }
            <BottomNavigation/>
        </div>
    )
}

export default OrderCondition